<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.7452 12.6878C13.1197 11.5883 14 9.89698 14 8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8C2 9.89697 2.88033 11.5883 4.25474 12.6878M11.7452 12.6878C10.7188 13.509 9.41673 14 8 14C6.58326 14 5.28121 13.509 4.25474 12.6878M11.7452 12.6878C10.6733 11.9725 9.38537 11.5555 7.99999 11.5555C6.61462 11.5555 5.32664 11.9725 4.25474 12.6878M10.8444 7.28889C10.8444 8.85983 9.57094 10.1333 8 10.1333C6.42906 10.1333 5.15556 8.85983 5.15556 7.28889C5.15556 5.71795 6.42906 4.44444 8 4.44444C9.57094 4.44444 10.8444 5.71795 10.8444 7.28889Z"
      stroke="var(--icon-border-default)"
    />
  </svg>
</template>
